module.exports = __webpack_public_path__ + "static/img/noshowPic.97b227b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/noshowPic.png
// module id = SOWr
// module chunks = 1